import React from 'react';
import WindmillGame from '../../features/apps/components/WindmillGame';

const WindmillGameRoute = () => {
  return <WindmillGame />;
};

export default WindmillGameRoute;
